export const color = {
    bg: "#71674B",
    fg: "white",
    hv:"#826b291d"
} 